module.exports = __webpack_public_path__ + "static/media/p3detail.174e7dd0.png";